import { dossierOmschrijvingenOptions } from "@/entities/dossier-details";
import { FormFieldAutocomplete, FormFieldInput } from "@/shared/components";
import { useFormContext, UseFormReturn } from "react-hook-form";

type OmschrijvingenFormValues = {
    omschrijving: string;
    omschrijvingExtraContext: string;
};

type OmschrijvingenForm = UseFormReturn<OmschrijvingenFormValues>;

export function Omschrijvingen() {
    const form = useFormContext() as OmschrijvingenForm;

    return (
        <div className="max-w-sm space-y-2">
            <FormFieldAutocomplete
                form={form}
                name="omschrijving"
                label="Omschrijving"
                placeholder="Kies een omschrijving"
                showSearchIcon={false}
                options={dossierOmschrijvingenOptions}
                data-testid="omschrijvingen"
            />
            <FormFieldInput form={form} name="omschrijvingExtraContext" placeholder="Extra context (optioneel)" />
        </div>
    );
}
